import type {FC, PropsWithChildren, ReactNode} from 'react';

import {Container} from '@/modules/foundation/components/container';
import {Heading} from '@/modules/foundation/components/typography/heading';
import type {PortableTextOverrides} from '@/modules/foundation/sanity/portable-text';

type Props = PropsWithChildren & {
	heading?: string;
	breadcrumb?: ReactNode;
};

export const textHeadingPortableTextOverrides: PortableTextOverrides = {
	callToActionLineProps: {
		callToActionProps: {
			size: 'lg',
		},
	},
	p: 'text-lg lg:text-xl',
	ol: 'text-lg lg:text-xl',
	ul: 'text-lg lg:text-xl',
};

export const TextHeading: FC<Props> = ({heading, children, breadcrumb}) => {
	return (
		<>
			<Container
				className="bg-neutral-600/20"
				spacingBottom="normal"
				spacingTop="normal"
				hasBackground
			>
				<div className="max-w-3xl">
					<Heading
						spacing={Boolean(children)}
						className="text-primary text-balance first-line:text-white"
					>
						{heading}
					</Heading>
				</div>
				{children}
			</Container>
			{breadcrumb && (
				<Container spacingBottom="small" spacingTop="small">
					{breadcrumb}
				</Container>
			)}
		</>
	);
};
